











import type { PropType } from 'vue';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import IconicList from '~/components/molecules/IconicList/IconicList.vue';
import { ListItemIcon, ListItemIconColor } from '~/components/atoms/IconicListItem/IconicListItemTypes';
import { ProductLocalisedAttributes } from '~/types/product/attribute/ProductLocalisedAttributes';
import ProductAnchorTitle from '~/components/atoms/Product/ProductAnchorTitle/ProductAnchorTitle.vue';

export default defineComponent({
  name: 'DeliveryPackage',
  components: {
    IconicList,
    ProductAnchorTitle,
  },
  props: {
    deliveryPackage: {
      type: Array as PropType<ProductLocalisedAttributes['deliveryPackage']>,
      default: () => {
        return [];
      },
    },
  },
  setup(props) {
    const packageItems = computed(() => props.deliveryPackage?.flatMap((localisedValues) =>
      localisedValues.values.map((item) => ({
        icon: ListItemIcon.checkmark,
        iconColor: ListItemIconColor.black,
        text: item,
      })),
    ));

    return {
      packageItems,
    };
  },
});
